import React, { useContext } from 'react'
import { modalContext } from 'global/context/sub-contexts/modalContext'

const SignInUpNav = () => {
  const modal_context = useContext(modalContext)
  const { showSignInModalTab } = modal_context || {}

  const openSignInModal = () => {
    showSignInModalTab()
  }

  return (
    <>
      <span onClick={openSignInModal}>
        <span className="action__text">Sign In</span>
      </span>
    </>
  )
}

export default SignInUpNav
